class GeolocationHandler {
    constructor() {
        this.answerKey = 'geolocation_answered';
        this.apiUrl = '/api/geolocation/set';
        this.csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    }

    init() {
        if (!this.isFeatureActive()) {
            return;
        }

        if (this.hasAnswered()) {
            return;
        }

        if (!navigator.geolocation) {
            return;
        }

        this.requestLocation();
    }

    isFeatureActive() {
        return window.zipCodePriceEnabled === true;
    }

    hasAnswered() {
        return sessionStorage.getItem(this.answerKey) === 'true';
    }

    markAsAnswered() {
        sessionStorage.setItem(this.answerKey, 'true');
    }

    requestLocation() {
        setTimeout(() => {
            navigator.geolocation.getCurrentPosition(
                (position) => this.onSuccess(position),
                (error) => this.onError(error),
                {
                    enableHighAccuracy: false,
                    timeout: 10000,
                    maximumAge: 0
                }
            );
        }, 1000);
    }

    async onSuccess(position) {
        const { latitude, longitude } = position.coords;
        this.markAsAnswered();
        try {
            const response = await fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ latitude, longitude })
            });
            const data = await response.json();
            if (data.success) {
                document.dispatchEvent(new CustomEvent('geolocation:updated', {
                    detail: data.location
                }));

                location.reload();
            }
        } catch (error) {
            console.error('Geolocation API error:', error);
        }
    }

    onError(error) {
        if (error.code === 1) {
            this.markAsAnswered();
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const geoHandler = new GeolocationHandler();
    geoHandler.init();
});

export default GeolocationHandler;
